export const APPLICATION_NAME = 'Messenger';

export const QUICK_OPTIONS_COUNT_LIMIT = 16;

export const QUICK_SUM_OPTIONS_LENGTH_LIMIT = 150;

export const QUICK_OPTION_LENGTH_LIMIT = 15;

export const GOODBYE_MESSAGE_HEADER = 'Survey Completed';

export const GOODBYE_MESSAGE_CONTENT = 'You have reached the end of the survey.';

export const INVALID_ERROR_MESSAGE = 'No response from server';

export const SURVEY_TESTING_PATH = 'survey-testing';

export const TIMEOUT_DELAY = 150;

export const SMALL_TIMEOUT_DELAY = 100;
